export class TrackState {
    currentSrc: string;
    currentTime: number;
}
